/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_4_1Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_4_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_4_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Useful for flat data exchange, not for preserving a workbook’s sheets, styles or charts.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_4_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_4_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适合交换普通表格数据，不能用来保留完整工作簿的多工作表、样式或图表。`)
};

/**
* | output |
* | --- |
* | "Useful for flat data exchange, not for preserving a workbook’s sheets, styles or charts." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_4_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_4_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_4_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_4_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_4_1(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_4_1(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_4_1 as "gc.search_guides.gridcraft_excel_compatibility.sections.3.table.rows.4.1" }